import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { RoleGuard } from 'app/core/auth/guards/role.guard';
import { LayoutComponent } from 'app/layout/layout.component';

export const appRoutes: Route[] = [

    // Public visitor QR registration page
    {
        path: 'visitor-registration',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: '', loadChildren: () => import('app/modules/public/visitor-registration/visitor-registration.routes')},
        ]
    },
    {
        path: 'visitor/:token',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: '', loadChildren: () => import('app/modules/public/visitor-registration/visitor-registration.routes')},
        ]
    },

    // Redirect empty path to '/dashboard'
    {path: '', pathMatch : 'full', redirectTo: 'dashboard'},

    // Redirect signed-in user to the '/dashboard'
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'membership-selection', loadChildren: () => import('app/modules/auth/membership-selection/membership-selection.routes')},
        ]
    },

    // Protected admin routes (Admin role required)
    {
        path: '',
        canActivate: [RoleGuard],
        canActivateChild: [RoleGuard],
        component: LayoutComponent,
        data: {
            roles: ['Admin'],
        },
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboard/dashboard.routes')},
            {path: 'visitors', loadChildren: () => import('app/modules/admin/visitors/visitors.routes')},
            {path: 'users', loadChildren: () => import('app/modules/admin/users/users.routes')},
            {path: 'complaints', loadChildren: () => import('app/modules/admin/complaints/complaints.routes')},
            {path: 'transactions/income', loadChildren: () => import('app/modules/admin/transactions/income/income.routes')},
            {path: 'transactions/expenses', loadChildren: () => import('app/modules/admin/transactions/expenses/expenses.routes')},
            {path: 'transactions/maintenance', loadChildren: () => import('app/modules/admin/transactions/maintenance/maintenance.routes')},
            {path: 'transactions/lock-month', loadChildren: () => import('app/modules/admin/transactions/lock-month/lock-month.routes')},
            {path: 'change-password', loadChildren: () => import('app/modules/auth/change-password/change-password.routes')},
        ]
    },
    // Platform routes (SuperAdmin role required)
    {
        path: 'platform',
        canActivate: [RoleGuard],
        canActivateChild: [RoleGuard],
        component: LayoutComponent,
        data: {
            roles: ['SuperAdmin'],
        },
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // Re-declare roles on each child: the parent path ('platform') is
            // non-empty, so Angular's default data inheritance does NOT pass the
            // parent's data.roles to children. Without this, the canActivateChild
            // RoleGuard would fall back to ['Admin'] and loop a SuperAdmin.
            {path: 'societies', data: {roles: ['SuperAdmin']}, loadChildren: () => import('app/modules/platform/societies/societies.routes')},
            {path: 'payments', data: {roles: ['SuperAdmin']}, loadChildren: () => import('app/modules/platform/payments/payments.routes')},
            {path: '', pathMatch: 'full', redirectTo: 'societies'},
        ]
    }
];
